import { Env, DOMAIN_ENV_ENUM } from '@myna/utils';
import { handleRealmName } from './helper';

// 开发环境指定环境，直接修改下面这个变量即可
const localEnv: DOMAIN_ENV_ENUM = DOMAIN_ENV_ENUM.DEV1;

const {
  mainDomain,
  developmentMainDomain,
} = handleRealmName(window.$scfEnv || localEnv); // 兼容本地开发环境

export const envInstance = new Env(
  window.$scfEnv,
  localEnv,
  mainDomain,
  developmentMainDomain,
);

// 获取 api 前置路径
export const { API_BASE, currentEnv } = envInstance;
export const ENV_PREFIX = window.location.host;
